import React, { useEffect } from 'react';
import {
    signInWithPopup,
    GoogleAuthProvider,
    getAuth,
    UserCredential,
} from 'firebase/auth';
import firebaseApp from 'Modules/firebase/firebase-config';

const auth = getAuth(firebaseApp);
const provider = new GoogleAuthProvider();

// Cross-browser compatible way to get parent origin
const PARENT_FRAME =
    document.location.ancestorOrigins?.[0] ||
    (document.referrer ? new URL(document.referrer).origin : '*');

function sendResponse(result: unknown): void {
    globalThis.parent.self.postMessage(JSON.stringify(result), PARENT_FRAME);
}

const GoogleSignInLanding: React.FC = () => {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            const trustedOrigins = [PARENT_FRAME];
            if (!trustedOrigins.includes(event.origin)) {
                console.warn(`Untrusted origin: ${event.origin}`);
                return;
            }
            const { data } = event;
            if (data && data.initAuth) {
                provider.setCustomParameters({
                    prompt: 'select_account',
                });
                signInWithPopup(auth, provider)
                    .then((result: UserCredential) => {
                        sendResponse(result);
                    })
                    .catch((error: Error) => {
                        sendResponse(error);
                    });
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div>
            <h1>Google Sign In Landing</h1>
        </div>
    );
};

export default GoogleSignInLanding;
